var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 362,
    viewBox: "0 0 251 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.402 36.2082V108.611L187.801 144.807V72.4032L125.201 108.598V181.002L62.601 144.807V72.4032L187.801 0L250.402 36.2082Z",
    fill: "#FE11C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.2 181L62.6 217.196L0 181L62.6 144.805L125.2 181Z",
    fill: "#FE11C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8 217.194V289.598L62.6 362L0 325.792V253.39L62.6 217.194V289.598L125.2 253.402V180.999L187.8 217.194Z",
    fill: "#FE11C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M250.41 181L187.809 217.196L125.209 181L187.809 144.805L250.41 181Z",
    fill: "#FE11C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 362,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.238ebbc6b4a4d9c17e3a76575de5b7f0.svg";
export { ForwardRef as ReactComponent };